import React from 'react';

const ShotListHeader = ({ column, color, sortDirection, onSort, onHeaderContextMenu }) => {
  const headerStyle = {
    backgroundColor: color,
    width: 'calc( 100% + 16px)',
    color: 'black',
    textAlign: 'center',
    transform: 'translateX(-8px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height:'100%'
  };

  const handleClick = () => {
    if (!onSort) return;
    const next = sortDirection === 'ASC' ? 'DESC' : 'ASC';
    onSort(column.key, next);
  }

  const handleContextMenu = e => {
    const ptrType = e.pointerType || e.nativeEvent.pointerType;
    if (ptrType === 'touch') return;

    e.preventDefault();
    e.stopPropagation();
    if (onHeaderContextMenu) onHeaderContextMenu(column.key);
  }

  const handleMouseDown = e => {
    if (e.pointerType === 'mouse' && e.button === 2) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div style={headerStyle} onClick={handleClick} onContextMenu={handleContextMenu} onMouseDown={handleMouseDown}>
        <div id={column.key} style={{fontSize:'13px', height: '100%', alignContent:'center',
          ...(column.unit && {lineHeight:'17px'})}}>
            {column.name}
            {column.unit ? <br/> : <></>}
            {
            column.unit ?
                "(" + column.unit + ")" : ""
            }
        </div>
    </div>
  );
};

export default ShotListHeader;